import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import omit from 'lodash/omit';
import isNull from 'lodash/isNull';

import {
  CLZ_UPDATE_1BOD_INFO,
  CLZ_CLEAR_1BOD_INFO,
  CLZ_SET_APPLICATION_TYPE,
  DEFAULT_CREDIT_AMOUNT,
  DEFAULT_TENOR,
  // REGEX,
  CLZ_TOGGLE_INSURANCE,
} from 'constants/clz';

const persistConfig = {
  key: 'firstBODInfo',
  storage,
  stateReconciler: autoMergeLevel2,
  blacklist: ['offerList', 'bestOffer'],
};

const initial1BOD = {
  phoneNumber: '',
  acceptedTerm: false,
  otp: '',
  creditAmount: DEFAULT_CREDIT_AMOUNT,
  tenor: DEFAULT_TENOR,
  firstName: '',
  lastName: '',
  middleName: '',
  dayOfBirth: '',
  gender: 'MALE',
  idCard: '',
  userImage: undefined,
  monthlyIncome: '',
  monthlyPayment: 0,
  identificationType: '',
  drivingLicence: '',
  familyBook: '',
  verificationID: null,
  offerList: [],
  bestOffer: {},
  retailAgent: '',
  sa: null,
  partnerCode: null,
  tipperCode: null,
  saleCode: null,
  excludedInsurance: false,
};

function firstBODInfo(state, action) {
  const newState = state || initial1BOD;
  const { payload } = action;

  if (action.type === CLZ_UPDATE_1BOD_INFO) {
    const { label, value } = payload;

    return { ...newState, [label]: value };
  }

  if (action.type === CLZ_CLEAR_1BOD_INFO) {
    return initial1BOD;
  }

  if (action.type === CLZ_SET_APPLICATION_TYPE) {
    const {
      partnerCode,
      tipperCode,
      saCode: retailAgent,
      saleCode,
      sa,
    } = payload;
    const applicationType = {
      partnerCode: null,
      tipperCode: null,
      retailAgent: null,
      sa: null,
      saleCode: null,
    };

    // detect applicationType is null
    // expect sa, some case sa = welcome | summary | ...
    const applicationTypeIsEmpty = Object.entries(omit(payload, 'sa')).every(
      ([key]) => isNull(payload[key]),
    );

    // if applicationType is collection of null
    if (applicationTypeIsEmpty) return { ...newState };

    applicationType.sa = sa;
    // NON-TIPPER PARTNER TYPE
    if (saleCode) {
      applicationType.partnerCode = partnerCode;
      applicationType.retailAgent = retailAgent;
      applicationType.saleCode = saleCode;
    } else if (partnerCode) {
      // TIPPER_PARTNER TYPE
      applicationType.partnerCode = partnerCode;
      applicationType.tipperCode = tipperCode;
      applicationType.retailAgent = retailAgent;
      // } else if (REGEX.INDIVIDUAL_TIPPER_HASH.test(sa) && tipperCode) {
      //   // TIPPER_INDIVIDUAL
      //   applicationType.tipperCode = tipperCode;
      //   applicationType.retailAgent = tipperCode;
    } else if (retailAgent) {
      // SA TYPE
      applicationType.retailAgent = retailAgent;
    }

    return { ...newState, ...applicationType };
  }

  if (action.type === CLZ_TOGGLE_INSURANCE) {
    return { ...newState, excludedInsurance: !newState.excludedInsurance };
  }

  return newState;
}

export default persistReducer(persistConfig, firstBODInfo);
